<template>
<div class="offer-main">
    <div class="share-txt" @click="shareClick">叫朋友来挑战</div>
    <div class="offerRusult-box">
        <img class="pencil"  src="../assets/img/pencil.png" alt="">
        <div v-for="(item,index) in offerImgList" :key="index">
            <img v-if="item.show === showFlag" :src="item.imgUrl" alt>
        </div>
        <img class="host-logo" src="../assets/img/LOGO_endpage.png" alt="">
        <div class="btn-box">
        <img  @click="againFun" src="../assets/img/button_end.png" alt="">
        <p @click="getJiexi" class="jiexi">获得解析</p>
        </div>
        <img class="yuanbao" src="../assets/img/yuanbao_share.png" alt="">
    </div>
    <div class="save-img-box" ref="imgTemplate">
        <div :key="index" v-for="(item,index) in shareImgList">
            <img class="save-bg" v-if="item.show === showFlag"  :src="item.imgUrl" alt="">
        </div>
        <div class="user-info">
            <img class="img" :src="userInfo.portraitUrl">
            <p class="nickname">{{userInfo.nickName}}</p>
        </div>
        <div class="erweima">
            <img :src="erweicode" alt="">
        </div>
    </div>
    <transition name="fade">
        <div class="mask" @click="showMask = !showMask" v-show="showMask"></div>
    </transition>
    <img :src="this.base64" class="img-template" @click='jiance'>
</div>
</template>
<script>
import html2canvas from 'html2canvas';

export default {
    data() {
        return {
            erweicode: '',
            showMask: false,
            showFlag: null,
            show: false,
            base64: '',
            offerImgList: [
                {
                    // imgUrl: 'http://wwj.jijiagames.com//web/act/20190410/civilian_end.png',
                    imgUrl: require('../assets/img/civilian_end.png'),
                    show: 'civilian'
                },
                {
                    // imgUrl: 'http://wwj.jijiagames.com//web/act/20190410/painter_end.png',
                    imgUrl: require('../assets/img/painter_end.png'),
                    show: 'painter'
                },
                {
                    // imgUrl: 'http://wwj.jijiagames.com//web/act/20190410/HR_end.png',
                    imgUrl: require('../assets/img/HR_end.png'),
                    show: 'HR'
                },
                {
                    // imgUrl: 'http://wwj.jijiagames.com//web/act/20190410/engineer_end.png',
                    imgUrl: require('../assets/img/engineer_end.png'),
                    show: 'engineer'
                },
                {
                    // imgUrl: 'http://wwj.jijiagames.com//web/act/20190410/poet_end.png',
                    imgUrl: require('../assets/img/poet_end.png'),
                    show: 'poet'
                },
                {
                    // imgUrl: 'http://wwj.jijiagames.com//web/act/20190410/prime minister_end.png',
                    imgUrl: require('../assets/img/prime minister_end.png'),
                    show: 'prime'
                },
                {
                    // imgUrl: 'http://wwj.jijiagames.com//web/act/20190410/sales_end.png',
                    imgUrl: require('../assets/img/sales_end.png'),
                    show: 'sales'
                }
            ],
            shareImgList: [
                {
                    imgUrl: require('../assets/img/civilian_share.jpg'),
                    show: 'civilian'
                },
                {
                    imgUrl: require('../assets/img/engineer_share.jpg'),
                    show: 'engineer'
                },
                {
                    imgUrl: require('../assets/img/HR_share.jpg'), show: 'HR'
                },
                {
                    imgUrl: require('../assets/img/painter_share.jpg'), show: 'painter'
                },
                {
                    imgUrl: require('../assets/img/poet_share.jpg'), show: 'poet'
                },
                {
                    imgUrl: require('../assets/img/prime minister_share.jpg'),
                    show: 'prime'
                },
                {
                    imgUrl: require('../assets/img/sales_share.jpg'), show: 'sales'
                }
            ]
        };
    },
    mounted() {
        this.testResultFlag();
        html2canvas(this.$refs.imgTemplate, {
            scale: 1,
            logging: false,
            useCORS: true
        }).then(c => {
            this.base64 = c.toDataURL('image/png', 1);
            setTimeout(() => {
            // this.show = true;
            }, 1000);
        });
        switch (this.$route.params.source) {
            case 'kzl':
                this.erweicode = require('../assets/img/kzl.jpg');
                /* eslint-disable-next-line */
                window._hmt.push(['_trackEvent', '市场kzl渠道', 'kzl渠道扫码进入 ', window.location.href]);
                break;
            case 'yxs':
                this.erweicode = require('../assets/img/yxs.jpg');
                /* eslint-disable-next-line */
                window._hmt.push(['_trackEvent', '市场yxs渠道', 'yxs渠道H5点击量 ', window.location.href]);
                break;
            case 'duomai':
                this.erweicode = require('../assets/img/duomai.jpg');
                /* eslint-disable-next-line */
                window._hmt.push(['_trackEvent', '市场duomai渠道', 'duomai渠道H5点击量 ', window.location.href]);
                break;
            default:
                this.erweicode = require('../assets/img/default.jpg');
                /* eslint-disable-next-line */
                window._hmt.push(['_trackEvent', '市场默认渠道', 'default渠道H5点击量 ', window.location.href]);
                break;
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.system.userInfo || {};
        }
    },
    methods: {
        testResultFlag() {
            const arr = this.$store.state.ancientOffer.testResult;
            if (arr.length === 5) {
                const one = arr[0];
                const two = arr[1];
                const three = arr[2];
                const four = arr[3];
                const five = arr[4];
                if (four === 'A' && five === 'B') {
                    this.showFlag = 'civilian';
                    this.tongji('市场获取不同职位数量', '获取游子职位数量');
                }
                else {
                    if(one === 'A' || one === 'B') {
                        if (two === 'A' || two === 'C') {
                            if (three === 'A' || three === 'C') {
                                this.showFlag = 'engineer';
                                this.tongji('市场获取不同职位数量', '获取工部尚书职位数量');
                            }
                            else if (three === 'B' || three === 'D') {
                                this.showFlag = 'painter';
                                this.tongji('市场获取不同职位数量', '获取画师职位数量');
                            }
                        }
                        else if (two === 'B' || two === 'D') {
                            if (three === 'A' || three === 'C') {
                                this.showFlag = 'painter';
                                this.tongji('市场获取不同职位数量', '获取画师职位数量');
                            }
                            else if (three === 'B' || three === 'D') {
                                this.showFlag = 'poet';
                                this.tongji('市场获取不同职位数量', '获取诗官职位数量');
                            }
                        }
                    }
                    else if (one === 'C' || one === 'D') {
                        if (two === 'A' || two === 'C') {
                            if (three === 'A' || three === 'C') {
                                this.showFlag = 'HR';
                                this.tongji('市场获取不同职位数量', '获取内务总管职位数量');
                            }
                            else if (three === 'B' || three === 'D') {
                                this.showFlag = 'prime';
                                this.tongji('市场获取不同职位数量', '获取丞相职位数量');
                            }
                        }
                        else if (two === 'B' || two === 'D') {
                            if (three === 'A' || three === 'C') {
                                this.showFlag = 'prime';
                                this.tongji('市场获取不同职位数量', '获取丞相职位数量');
                            }
                            else if (three === 'C' || three === 'D') {
                                this.showFlag = 'sales';
                                this.tongji('市场获取不同职位数量', '获取使臣职位数量');
                            }
                        }
                    }
                }
            }
        },
        shareClick() {
            this.showMask = true;
            this.tongji('市场分享统计', '市场分享点击数量');
        },
        againFun() {
            this.$emit('next', 2);
            this.tongji('市场重新返回第二页', '重新玩一次点击统计');
        },
        // 获得解析
        getJiexi() {
            window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzUzOTg0NjgyMA==&scene=124#wechat_redirect';
            this.tongji('市场点击解析跳转', '解析跳转统计');
        },
        jiance() {
            this.tongji('市场长按保存图片', '保存图片数量统计');
        },
        tongji(txt1, txt2) {
            switch (this.$route.params.source) {
                case 'kzl':
                    // eslint-disable-next-line
                    window._hmt.push(['_trackEvent', txt1, `kzl${txt2}`, window.location.href]);
                    break;
                case 'yxs':
                    // eslint-disable-next-line
                    window._hmt.push(['_trackEvent', txt1, `yxs${txt2}`, window.location.href]);
                    break;
                case 'duomai':
                    // eslint-disable-next-line
                    window._hmt.push(['_trackEvent', txt1, `duomai${txt2}`, window.location.href]);
                    break;
                default:
                    // eslint-disable-next-line
                    window._hmt.push(['_trackEvent', txt1, `default${txt2}`, window.location.href]);
                    break;
            }
        }
    }
};
</script>
<style lang="stylus" scoped>
@font-face
    font-family: 'shuti'
    src:url('/font/shuti.ttf') format('truetype')
.offer-main
    position relative
    text-align center
    width: 100%;
    height: 100%;
    background url("http://wwj.jijiagames.com//web/act/20190410/BG_endpage.png") 0 0/100% 100% no-repeat
    font-size: 0.3rem;
    .share-txt
        position absolute
        top 0
        font-size 0.26rem
        width 100%
        height 0.5rem
        line-height 0.5rem
        text-decoration underline
        text-align center
        z-index 999
        padding-left 2rem
    .offerRusult-box
        position relative
        top 0.6rem
        display flex
        justify-content center
        .pencil
            animation down 1.2s ease-out infinite
            position absolute
            left 0
            top -0.4rem
        .host-logo
            position absolute
            left 0.7rem
            bottom 0.15rem
        .btn-box
            position absolute
            top 8.78rem
            left: 50%;
            z-index 1000
            transform: translateX(-50%)
            .jiexi
                text-align center
                font-family shuti
                margin-top 0.1rem
        .yuanbao
            animation down 1.2s ease-out infinite
            position absolute
            right 0
            bottom 1.05rem
    .save-img-box
        size 750px 1334px
        position fixed
        top 100rem
        left 0
        .user-info
            z-index 1000
            display flex
            align-items center
            position absolute
            top 0.4rem
            left 0.6rem
            .img
                float left
                width 0.8rem
                height 0.8rem
                border-radius 50%
                object-fit cover
                margin-right 0.2rem
            .nickname
                float left
                padding-top 0.1rem
        .erweima
            position absolute
            bottom 0.3rem
            right 0.8rem
            z-index 999
            img
                size 92px
    .img-template
        size 100%
        position fixed
        top 0
        left 0
        z-index 5
        opacity 0
    @keyframes down
        0%
            transform translateY(0)
        30%
            transform translateY(-5px)
        50%
            transform translateY(-6px)
        100%
            transform translateY(0px)
    .mask
        size 100%
        position fixed
        top 0
        z-index 2000
        background rgba(0,0,0,.8) url('../assets/img/share_tip.png') 94% 4%/1.84rem 1.71rem no-repeat
</style>
